// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3M4wB","footer":"ModalCreateQualiphyProcedure_footer__pG-S9","additionData":"ModalCreateQualiphyProcedure_additionData__2r3fQ"};